import request from "@/request/request"

export function userLogin(data) {
  return request({
    url: '/auth/login',
    method: 'POST',
    data
  })
}

export function user2FALogin(data) {
  return request({
    url: '/auth/login2FA',
    method: 'POST',
    data
  })
}

export function generate_2FA_QR(data) {
  return request({
    url: '/user/generate2FAURL',
    method: 'POST',
    data
  })
}
export function verify2FA(data) {
  return request({
    url: '/user/verify2FA',
    method: 'POST',
    data
  })
}
export function disable2FA(data) {
  return request({
    url: '/user/disabled2FA',
    method: 'POST',
    data
  })
}
export function userPermission() {
  return request({
    url: '/auth/getAccess',
    method: 'GET'
  })
}

export function updateMapEngine(data) {
  return request({
    url: '/auth/updateMapEngine',
    method: 'POST',
    data
  })
}

export function getUserLogon() {
  return request({
    url: '/auth/getLogonUser',
    method: 'POST'
  })
}

const TokenKey = 'TrackVisionToken'
export function userLogout() {
  const token = localStorage.getItem(TokenKey);
  return request({
    url: '/auth/logout',
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
}